import React, {useEffect, useContext} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  let durationOptions = []
  let timeOptions = ['Yes', 'No']
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['TimeField'], true, true, false)
  }, [group_id, getAdditionalFieldValues])
  return (
    <>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Duration between</InputLabel>
        <Select
          labelId=""
          label="Duration between"
          id=""
          value={data}
          onChange={onChange}
          style={{width: '200px'}}
        >
          {durationOptions.map(opt => {
            return <MenuItem value={opt.name}>{`${opt.name} - ${opt.symbol}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">and</InputLabel>
        <Select
          labelId=""
          label="and"
          id=""
          value={data}
          onChange={onChange}
          style={{width: '200px'}}
        >
          {durationOptions.map(opt => {
            return <MenuItem value={opt.name}>{`${opt.name} - ${opt.symbol}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Display in Days, Hours and Minutes</InputLabel>
        <Select
          labelId=""
          label="Display in Days, Hours and Minutes"
          id=""
          value={data}
          onChange={onChange}
          style={{width: '200px'}}
        >
          {timeOptions.map(opt => {
            return <MenuItem value={opt}>{`${opt}`}</MenuItem>
          })}
        </Select>
      </FormControl>
    </>
  )
}

export default FTextField
